"use strict";
var processInclude = require("base/util");
var AOS = require("./components/aos");
$(document).ready(function () {
    processInclude(require('./components/aos'));
    AOS.init({
        duration: 1500,
        once: true,
    });        
});

$(window).on('load', function () {
    AOS.refresh();
})

const aosFinding = setInterval(() => {
    if ($('.section-recommend').length) {
        AOS.init({
            once: true
        });
        clearInterval(aosFinding);
    }
}, 300);

const aosFindRecommend = setInterval(() => {
    if ($('#is-recommend-area-men-top, #is-recommend-area-women-top').length) {
        let container = $('#is-recommend-area-men-top .recommend-block, #is-recommend-area-women-top .recommend-block');
        if (container.length) {
            container.each(function () {
                $(this).attr('data-aos', 'fade-in');
            });
            AOS.init({
                once: true
            });
            clearInterval(aosFindRecommend);
        }
    } else {
        clearInterval(aosFindRecommend);
    }
}, 300);